module.exports = __webpack_public_path__ + "img/bootcamp-hero-m.3be2961a.jpg";